import { ToggleButton, ToggleButtonItem } from '@apply/components';
import React from 'react';
import { DashboardClosedByMonthPivotMode } from '../../../../../../constants/DashboardClosedByMonthPivotMode';

export const DashboardClosedByMonthPivotToggleButton: React.FC<{
    pivotMode: DashboardClosedByMonthPivotMode;
    set_pivotMode: (mode: DashboardClosedByMonthPivotMode) => void;
}> = ({ pivotMode, set_pivotMode }) => {
    const pivotModes: ToggleButtonItem[] = [
        {
            id: DashboardClosedByMonthPivotMode.Committed,
            text: 'Commitments',
            hint: 'Display Committed Amounts',
        },
        {
            id: DashboardClosedByMonthPivotMode.Number,
            text: 'Number',
            hint: 'Display the Number of Closed Loans',
        },
    ];
    return (
        <ToggleButton
            id='dashboardClosedbyMonthPivotToggleButton'
            items={pivotModes}
            selectedItems={[pivotMode]}
            stylingMode='outlined'
            selectionMode='single'
            onItemClick={(e) => set_pivotMode(e?.itemData.id)}
            width='270px'
            height='24px'
            required={true}
        />
    );
};
